export default "__VITE_ASSET__C61g1bjX__"